import { useSelector } from "react-redux";

const useCurrentSite = () => {
  const { selectedSite } =
    useSelector((state) => state.adminActions.sites) || {};
  return selectedSite;
};

export default useCurrentSite;
